module.exports = __webpack_public_path__ + "img/union.5f461fe4.png";